export default __webpack_public_path__ + "static/media/tete79.140dda50.png";